import SystemMessage from "../model/SystemMessage";
import SystemMessageOption from "../model/SystemMessageOption";

export default class SystemMessageBuilder {
    constructor() {
        this._title = '';
        this._description = '';

        /** @type {Array<SystemMessageOption>} */
        this._options = [];
    }

    setTitle(value) {
        this._title = value;

        return this;
    }

    setDescription(value) {
        this._description = value;

        return this;
    }

    /**
     * 
     * @param {{ text: String, callback: Function, preventClose: boolean }} option 
     * @returns 
     */
    addOption({ text, callback, preventClose }) {
        this._options.push(new SystemMessageOption(text, callback, preventClose));

        return this;
    }

    build() {
        return new SystemMessage(this._title, this._description, this._options);
    }
}